'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerScrolled = function () {
  function headerScrolled() {
    (0, _classCallCheck3.default)(this, headerScrolled);

    this.mainHeader = document.querySelector('.main-header');
    this.initialHeaderHeight = this.mainHeader.offsetHeight;
    this.setInitialHeaderHeight = false;
    this.isInTop = false;

    this.footerHeight = document.querySelector('.footer').offsetHeight;

    this.headerWrap = document.querySelector('[data-header-wrap]').getBoundingClientRect().top;

    this.mainTag = document.querySelector('#MainContent');

    // use for search position
    //this.headerNavTop = document.querySelector('.header').getBoundingClientRect().top;

    this.documentTop = document.documentElement.getBoundingClientRect().top;

    this.lastScrollTop = 0;

    // Upperbar
    this.upperbar = document.querySelector('[data-upperbar]');

    if (this.upperbar) {
      this.upperbarOnlytop = this.upperbar.classList.contains('upperbar--only-top');
      this.upperbarHeight = this.upperbar.offsetHeight;
    }
  }

  (0, _createClass3.default)(headerScrolled, [{
    key: 'initEvents',
    value: function initEvents() {
      var _this = this;

      document.addEventListener('DOMContentLoaded', function () {
        _this.setCssVariables();
        _this.checkWindowTop();
      });

      window.addEventListener('theme:resize', this.updateCssVariables, false);

      document.addEventListener('theme:scroll', function () {
        _this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        _this.headerWrap = document.querySelector('[data-header-wrap]').getBoundingClientRect().top;

        if (_this.scrollPosition > _this.lastScrollTop) {

          if (_this.headerWrap <= 0) {
            _this.mainHeader.classList.add('is-fixed');
            _this.updateCssVariables();

            if (_this.upperbarOnlytop) {
              document.documentElement.style.setProperty('--paddingBody', _this.initialHeaderHeight + 'px');
            } else {
              // apply only first time
              _this.checkInitialHeightSet();
            }
          }

          _this.mainHeader.classList.remove('on-top');
          _this.mainHeader.classList.remove('scroll-up');
          _this.mainHeader.classList.add('scroll-down');

          // set search position only if scroll down is small
          _this.headerNavTop = document.querySelector('.header').getBoundingClientRect().top;
          document.documentElement.style.setProperty('--headerNavTop', _this.headerNavTop + 'px');
        } else {
          _this.mainHeader.classList.add('scroll-up');
          _this.mainHeader.classList.remove('scroll-down');
          _this.updateCssVariables();

          if (_this.mainTag.getBoundingClientRect().top > _this.mainHeader.offsetHeight) {
            if (_this.mainHeader.classList.contains('is-fixed') && !_this.upperbarOnlytop) {
              _this.isTop();
            }
          }

          if (_this.mainHeader.classList.contains('is-fixed')) {
            if (_this.upperbarOnlytop && window.scrollY <= _this.upperbarHeight) {
              _this.mainHeader.classList.add('on-top');
              _this.mainHeader.classList.remove('is-fixed');
              document.documentElement.style.setProperty('--paddingBody', '0px');
            } else if (window.scrollY === 0) {
              _this.mainHeader.classList.add('on-top');

              setTimeout(function () {
                _this.mainHeader = document.querySelector('.main-header');
                _this.headerHeight = _this.mainHeader.offsetHeight;
                document.documentElement.style.setProperty('--paddingBody', _this.headerHeight + 'px');
              }, 120);
            } else {
              _this.mainHeader.classList.remove('on-top');
            }
          }
        }

        _this.lastScrollTop = _this.scrollPosition <= 0 ? 0 : _this.scrollPosition;
      }, true);
    }
  }, {
    key: 'setCssVariables',
    value: function setCssVariables() {
      setTimeout(function () {
        this.mainHeader = document.querySelector('.main-header');

        this.headerHeight = this.mainHeader.offsetHeight;
        this.headerNavTop = document.querySelector('.header').getBoundingClientRect().top;

        document.documentElement.style.setProperty('--paddingSticky', this.headerHeight + 'px');
        document.documentElement.style.setProperty('--headerHeight', this.headerHeight + 'px');
        document.documentElement.style.setProperty('--headerNavTop', this.headerNavTop + 'px');
      }, 10);
    }
  }, {
    key: 'updateCssVariables',
    value: function updateCssVariables() {
      this.mainHeader = document.querySelector('.main-header');
      this.headerHeight = this.mainHeader.offsetHeight;
      this.headerNavTop = document.querySelector('.header').getBoundingClientRect().top;

      document.documentElement.style.setProperty('--paddingSticky', this.headerHeight + 'px');
      document.documentElement.style.setProperty('--headerHeight', this.headerHeight + 'px');
      document.documentElement.style.setProperty('--headerNavTop', this.headerNavTop + 'px');

      // if (this.isInTop) {
      //   document.documentElement.style.setProperty('--paddingBody', `${this.headerHeight}px`);
      // }
    }
  }, {
    key: 'checkWindowTop',
    value: function checkWindowTop() {
      if (this.documentTop !== 0) {
        this.setHeaderFixed();
      }
    }
  }, {
    key: 'setHeaderFixed',
    value: function setHeaderFixed() {
      if (this.headerWrap <= 0) {
        this.mainHeader.classList.add('is-fixed');
        this.updateCssVariables();
      }

      return false;
    }
  }, {
    key: 'checkInitialHeightSet',
    value: function checkInitialHeightSet() {
      if (!this.setInitialHeaderHeight) {
        this.setInitialHeaderHeight = true;
        document.documentElement.style.setProperty('--paddingBody', this.initialHeaderHeight + 'px');
      }

      return false;
    }
  }, {
    key: 'isTop',
    value: function isTop() {
      if (!this.isInTop) {
        this.isInTop = true;

        this.mainHeader = document.querySelector('.main-header');
        this.headerHeight = this.mainHeader.offsetHeight;
        document.documentElement.style.setProperty('--paddingBody', this.headerHeight + 'px');

        // prevent body jumping in change of padding-top
        window.scrollTo(0, 0);
      }

      return false;
    }
  }]);
  return headerScrolled;
}();

exports.default = headerScrolled;